import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useNavigationType } from 'react-router-dom';
import { useUserStore } from '../store/useUser';
import { navigateToClub } from '../utils/club';

function useHistoryStack() {
  const [stack, setStack] = useState([]);
  const { pathname } = useLocation();
  const type = useNavigationType();
  const navigate = useNavigate();
  const profile = useUserStore(state => state.profile)
  const club = useUserStore(state => state.club)
  const userId = useUserStore(state => state.id)

  useEffect(() => {
    if (type === "POP") {
      setStack(prev => prev.slice(0, prev.length - 1));
    } else if (type === "PUSH") {
      setStack(prev => pathname !== prev[prev.length - 1] ? [...prev, pathname] : [...prev, pathname]);
    } else {
      setStack(prev => [...prev.slice(0, prev.length - 1), pathname]);
    }
  }, [pathname, type]);

  function goBack(){
    let nextPath = '/';

    switch(profile) {
      case 'Clubista':
        nextPath = `/user/${userId}`
        break
      case 'Criador':
        nextPath = navigateToClub(club.name, club.id)
        break
      case 'Mediador':
        nextPath = navigateToClub(club.name, club.id)
        break
      default:
        nextPath = '/';
        break
    }

    setStack(prev => prev.slice(0, prev.length - 2));
    navigate(stack[stack.length - 2] || nextPath || '/')
  }

  return { stack, goBack };
}

export default useHistoryStack;